const BENCHMARK_LEADER_METRIC_DICTIONARY_PROD = [
  'M1717789682',
  'M1743540759',
  'M1758686120',
  'M1758697104',
];

const BENCHMARK_LEADER_METRIC_DICTIONARY_GAMMA = [
  'M1717789682',
  'M1743540759',
  'M1758686120',
  'M1758697104',
];

const BENCHMARK_LEADER_METRIC_DICTIONARY_BETA = [
  'M1674506560',
  'M1743540759',
  'M1746040713',
  'M1758697104',
];

const LEADER_BENCHMARK_STAGE_VALUES = {
  BENCHMARK_LEADER_METRIC_DICTIONARY_PROD,
  BENCHMARK_LEADER_METRIC_DICTIONARY_GAMMA,
  BENCHMARK_LEADER_METRIC_DICTIONARY_BETA,
};

export default LEADER_BENCHMARK_STAGE_VALUES;
